import React from "react";
import { motion } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";
import { useSound } from "../../sound/SoundContext";

export default function SoundToggle() {
  const { muted, toggleMuted, play } = useSound();

  const onClick = () => {
    toggleMuted();
    if (muted) setTimeout(() => play("sparkle"), 40); // was muted -> now on
  };

  return (
    <motion.button
      onClick={onClick}
      data-testid="mute-toggle"
      aria-label={muted ? "Unmute sounds" : "Mute sounds"}
      whileTap={{ scale: 0.88 }}
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 200, damping: 14 }}
      className="fixed bottom-5 right-5 z-[70] bg-white text-pusheen-brown border-[3px] border-pusheen-brown rounded-full p-3.5 shadow-[3px_3px_0_#4A3728] hover:bg-pusheen-cream hover:-translate-y-0.5 active:translate-y-[3px] active:shadow-none transition-all"
    >
      {muted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
    </motion.button>
  );
}
